<template>
	<div class="fixed-tool">
		<ul class="flex">
			<li @click="$router.back()">
				<img src="../assets/images/fixed-left-icon.png" alt="" />
			</li>
			<li @click="$router.push('/')">
				<img src="../assets/images/fixed-home-icon.png" alt="首页" />
			</li>
		</ul>
	</div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.fixed-tool {
	position: fixed;
	top: 10px;
	left: 14px;
	z-index: 999;
	width: 88px;
	padding: 10px 0;
	background: rgba(0, 0, 0, 0.35);
	border-radius: 20px;
	& > ul {
		width: 100%;
		li {
			flex: 1 0 auto;
			text-align: center;
			font-size: 12px;
			height: 20px;
			img {
				vertical-align: middle;
        width: 20px;
			}
		}
		li:first-child {
			border-right: 1px solid #ffffff;
		}
	}
}
</style>
